<template>
  <v-container fluid fill-height>
    <iframe class="responsive-iframe" :src="homeDashboard.link" frameborder="0" style="border:0" allowfullscreen></iframe>
  </v-container>
</template>

<script>
import Vue from "vue";
import { apiv1 } from "../../libs/apiv1";
import { Auth } from "../../classes/Auth";
const auth = new Auth();
export default Vue.extend({
  name: "Dashboard2",
  props: {
    source: String,
  },
  async mounted() {
    await this.getHomeDashboard();
  },
  data: () => ({
    homeDashboard: {},
    auth: new Auth(),
  }),
  methods: {
    async getHomeDashboard() {
      const { data } = await apiv1({
        url: `/project/home-dahsboard/${auth.getProject().id}`,
        method: "GET",
      });
      this.homeDashboard = data;
    },
  },
});
</script>

<style>
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 10px; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>

